/**
 * Reset Responsive Attributes Utility
 *
 * Utility function for resetting all responsive attributes
 *
 * @package RedfoxThankYou
 * @since 1.0.0
 */

import type { ResponsiveAttributes } from '../../types';

/**
 * Reset all responsive attributes
 */
export const resetResponsiveAttributes = < T >(): Partial<
	ResponsiveAttributes< T >
> => {
	return {
		desktop: {} as T,
		tablet: {} as T,
		mobile: {} as T,
	};
};
